


































import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";
import _ from "lodash";
import EventBus from "front-component/EventBus";
import Tag from "@/components/miscellaneous/Tag.vue";

@Component({ components: { Tag } })
export default class SelectGroupSearch extends Vue {
    @Prop({ default: "" }) public value!: string;
    @Prop() public filterName!: string;
    @Prop() public options!: object[];
    @Prop() public classes!: string;
    @Prop() public placeholder!: string;
    @Prop({ default: "" }) public selectStyle!: string;
    @Prop({ default: false }) public multiple!: boolean;

    private filter: string = "";

    public mounted(): void {
        this.filter = this.value;
    }

    @Watch("value") public updateValue() {
        this.filter = this.value;
    }

    @Watch("filter") public onFilterChange(value: string): void {
        EventBus.$emit("update-filter", _.set({}, this.filterName, value));
    }
}
